import styled from "styled-components";
import { logo } from "../../images";
import { device } from "../../helpers/style";

const width = 131;
const height = 201;
const scale = 1;

const marginLeft = -1 * (width / 2);

export const Logo = styled.img.attrs({
    src: logo,
})`
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -${height * 0.5}px;
    margin-left: ${marginLeft}px;
    width: ${width}px;
    height: ${height}px;

    @media ${device.phone} {
        width: ${width * scale}px;
        height: ${height * scale}px;
    }
`;
